import {isJWT, parseJwt} from './jwt';
import isEmpty from 'lodash/isEmpty';
/**
 * setAttribute set's a specific localStorage key value pair 
 */
const setAttribute = (field, data) => localStorage.setItem(field, data);

/** 
 * getObject is used to return back the full JSON representation
 * of the JWT token decrypted. 
 * JSON.parse() in this context can throw an exception if input is malformed, already an object, or undefined
 */
const getObject = field => {
    try {
        return JSON.parse(localStorage.getItem(field)); 
    } catch (ex) { 
        return null;
    }
};

const logout = () => {
    setAttribute(`token-${process.env.REACT_APP_APPID}`, null);
    setAttribute(`token`, null);
    window?.google?.accounts?.id?.disableAutoSelect();
};

const getCookie =(cookieName) => {
    let name = cookieName + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');

    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

const getBearerToken = () => {
    const token = localStorage.getItem(`token-${process.env.REACT_APP_APPID}`);

    if (!isJWT(token)) return '';
    return token;
}

const setBearerToken = (token) => {
    localStorage.setItem(`token-${process.env.REACT_APP_APPID}`, token);
};


const isAuthenticated = () => {
    const platformToken = getBearerToken();
    const platformJWTObject = parseJwt(platformToken);
    if (isEmpty(platformJWTObject)) return false;
    if (platformJWTObject.exp < (new Date().getTime() / 1000))
        return false;
    
    return true;
};

const hasPermission = (entity, permission) => {
    const permissions = getObject('permissions');
    if (!permissions) return false;
    const perm = permissions
        .find(x => x.entity === entity && x.permission === permission);

    return !!perm;
};

export default {
    isAuthenticated,
    logout,
    hasPermission,
    getCookie,
    getBearerToken,
    setBearerToken,
};
